import { IVisaPrepForm } from '../../../../../../types';

type Fields = Pick<
  IVisaPrepForm,
  | 'hasReceivedCas'
  | 'studiesConfirmationNumber'
  | 'courseEndDate'
  | 'alreadyStartedStudying'
  | 'studyAddress'
  | 'assessedBySponsor'
>;

type Params = Fields & {
  courseEndDateError: string;
};

export function getPageStatus({
  hasReceivedCas,
  studiesConfirmationNumber,
  courseEndDate,
  alreadyStartedStudying,
  studyAddress,
  assessedBySponsor,
  courseEndDateError
}: Params): { complete: boolean } {
  let complete = false;
  if (
    hasReceivedCas === undefined ||
    (hasReceivedCas === true && (studiesConfirmationNumber === undefined || studiesConfirmationNumber === '')) ||
    (hasReceivedCas === true && (courseEndDateError !== '' || courseEndDate === undefined || courseEndDate === '')) ||
    alreadyStartedStudying === undefined ||
    (hasReceivedCas === true && (studyAddress === undefined || studyAddress === '')) ||
    assessedBySponsor === undefined
  ) {
    complete = false;
  } else {
    complete = true;
  }

  return { complete };
}
